import merge from 'lodash-es/merge';
import defaultsDeep from 'lodash-es/defaultsDeep';
import getDefaultStyle from '../css/defaultStyle';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import frameProps from '../css/frameProps';
import { updateClasses, getDefaultControl } from './video.defaults';
import Control from './control';
import uniqueId from '../uniqueId';
import VideoAPI from '../../videoApi';
import {renderControls} from '../renderControls';

var icons = {
  snapshot:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z' /%3E%3C/svg%3E",  
};


const defaultFrame = {
  position: 'absolute',
  display: 'block',
  overflow: 'hidden',
  top: '8px',
  left: '8px',
  width: '640px',
  height: '360px',
  userSelect: 'none',
}

export default class Video extends Control {

  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);
    // this._defaultShow = false;
    //
    
    this.addApi(this, 'url', () => {    
      return this._checkDataOption(
        'url',
        this._controlOptions.url,
      );
    });
    this._icons = {...icons};
  }


  onReady(){
    super.onReady();
    if(this.isLayoutMode) {return;}

    this.on('videoSnapshot', (event, control, component, anchor, data) => {      
      this.value = data[1].image;
      component.render();
    });

    this.on('videoPause,videoError', (event, control, component)=>{
      const sw = component.getControl(control.id+'_switch');
      if(sw&&sw.isChecked){
        sw.setIsChecked(false);
      }
    });

    this.on('videoPlay', (event, control, component)=>{
      const sw = component.getControl(control.id+'_switch');
      if(sw&&!sw.isChecked){
        sw.setIsChecked(true);
      }
    });
  }
  
  renderElement() {
    const control = this;
    const options = this._controlOptions;
    
    //classList:['no-layout'],

    if (!control.el) {
      control.el = getDefaultControl(control);
      if(!control.id){
        control.id = uniqueId(control.el, 'recharts-video-',Video);
        control.styleSheet = 'css-' + control.id;        
      }else{
        control.el.setAttribute('id',control.id);
      }

      control.video = new VideoAPI(control, 'options', control.el.getElementsByClassName('body')[0]);
    }

    options.controls = [];

    if(options.snapshot){
      defaultsDeep(options.snapshot, this.getDefaults().snapshot);
      options.snapshot.name = control.id+'_snapshot';
      options.controls.push(options.snapshot);
    }

    if(options.switch){
      defaultsDeep(options.switch, this.getDefaults().switch);
      options.switch.name = control.id+'_switch';
      options.controls.push(options.switch);
    }


    
    

    updateClasses(control,options);
    
    
    
    


    

    var frameStylePatch = _.pick(merge({},getDefaultStyle(),defaultFrame, options.style.normal), frameProps);
    

    if(options.mirror){
      const body = control.el.getElementsByClassName('body')[0];
      body.style.transform = 'scaleX(-1)';
    }

    let scheme = lookAndFeel(options.lookAndFeel, options.style.normal.height);

    updateStyleByRef(frameStylePatch, scheme);
    updateStyle(control.el, frameStylePatch, control.currentFrameStyle);

    control.currentFrameStyle = frameStylePatch;

    //bodyEl.innerHTML = control.text === undefined || control.text === null? '':control.text;
    
    // if(control._prevUrl !==control.url){
    //   bodyEl.setAttribute('src', control.url);      
    //   control._prevUrl = control.url;
    // }
    control.video.setUrl(control.url);

    options.controls.forEach(function(ctrl) {
        ctrl.lookAndFeel = merge({}, options.lookAndFeel, ctrl.lookAndFeel);
        if (!ctrl.style) {
          ctrl.style = {};
        }

        ctrl.style.normal = merge({}, ctrl.style.normal, {
          pointerEvents: 'auto',
        });
      });

      renderControls(this.instance, this.path, control.nicePath, control.el);

    return control.el;
  }

  dropBoxGetFileUrl({path,name}){
    return this.instance.dropBoxGetFileUrl({path,name});
  }

  getDefaults(){
    if(!this._defaults){
      this._defaults = {
          snapshot:{
            type: 'button',
            tooltip:{
              text:'Take a snapshot',
              type:'basic'
            },
            style: {
              normal:{
                top:'auto',
                bottom:'8px',
                left:'50%',
                height:'64px',
                width:'64px',
                transform:'translateX(-50%)',
                borderRadius:'50%',
                opacity:0.3
              },
              hover:{
                opacity:0.5
              }
            },
            lookAndFeel:{
              background:'#000000',
              controlsDesign:'flat'
            },
            icon: {
              url: this._icons.snapshot,
              size:'70%'
            },
            label:{
              visible:false,
              text:'Take snapshot'
            },
            classList:['no-layout'],            
            triggers: {
              click: function(eventId, control, component, anchor, data) {
                control.parentControl.video.takeSnapshot();                
              }
            }
          },
        switch: {
          type: 'switch',
          tooltip:{
            text:'Switch camera on/off',
            type:'basic'
          },
          style: {
            normal:{
              top:'8px',
              bottom:'auto',
              left:'8px',
              height:'16px',
              width:'32px',              
              opacity:0.3
            },
            hover:{
              opacity:0.5
            }
          },
          lookAndFeel:{
            foreground:'#000000',
            background:'#FFFFFF',
            controlsDesign:'flat'
          },
          classList:['no-layout'],            
          triggers: {
            isChecked: function(event, control) {
              if(control.isChecked){
                if(control.parentControl.video.isPaused()){
                  control.parentControl.video.play();                  
                }
              }else{
                if(!control.parentControl.video.isPaused()){
                  control.parentControl.video.stop();
                }
              }
            }
          }
        }
      };
    }

    return this._defaults;
  }
}
